const AllChannelStatistics = () =>
  import('@/views/main/wechatMgmt/allChannelStatistics/AllChannelStatistics.vue')
export default {
  path: '/main/wechatMgmt/allChannelStatistics',
  name: 'AllChannelStatistics',
  component: AllChannelStatistics
}
